import { Button, Col, Row, Space, Form } from "antd";
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import InputBox from "../../../components/common/input";
import { useDispatch, useSelector } from "react-redux";
import { addSubscriptionFun, updateSubscriptionFun } from "../../../redux/reducer/SubscriptionSlice";

const AddSubscription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  
  const subscriptionDetails = location.state?.subscriptionData || null;



  const {addSubLoading, AddSubError, updateSubLoading, updateSubError} = useSelector(
    (state) => state?.subscription
  );

 
  // const subscriptionDetails = location.state || null; // Get data from navigation

  // Pre-fill form if data exists (editing mode)
  useEffect(() => {
    if (subscriptionDetails) {
      form.setFieldsValue(subscriptionDetails);
    }
  }, [subscriptionDetails, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      if (subscriptionDetails) {
        await dispatch(updateSubscriptionFun({ id: subscriptionDetails?.id, data: values }));
      } else {
        await dispatch(addSubscriptionFun(values));
      }
      navigate('/manage-subscription');
    } catch (error) {
      console.log("Validation Failed:", error);
    }
  };

  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">{subscriptionDetails ? "Edit Subscription Details" : "Add Subscription Details"}</div>
      </div>

      <Form form={form} requiredMark="optional" layout="vertical">
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item
             label={<span>Subscription Name (en)<span style={{ color: "red" }}>*</span></span>}
           
              name="name_en"
              rules={[{ required: true, message: "Please enter subscription name (en)" }]}
            >
              <InputBox size="large" placeholder="Enter subscription name (en)" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
             label={<span>Subscription Name (es)<span style={{ color: "red" }}>*</span></span>}
           
              
              name="name_es"
              rules={[{ required: true, message: "Please enter subscription name (es)" }]}
            >
              <InputBox size="large" placeholder="Enter subscription name (es)" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
            label={<span>Subscription Name (pt)<span style={{ color: "red" }}>*</span></span>}
             
              name="name_pt"
              rules={[{ required: true, message: "Please enter subscription name (pt)" }]}
            >
              <InputBox size="large" placeholder="Enter subscription name (pt)" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              label={<span>Price <span style={{ color: "red" }}>*</span></span>}

              name="price"
              rules={[
                { required: true, message: "Please enter price" },
                { pattern: /^\d+(\.\d{1,2})?$/, message: "Enter a valid price (e.g., 500.00)" },
              ]}
            >
              <InputBox size="large" placeholder="Enter price in USD ($)" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      
      <div className="addBtnBx d-end">
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={handleSave}>
            {subscriptionDetails ? updateSubLoading ? "Loading..." :  "Update Details" : addSubLoading ?  "Loading..." :"Save Details"}
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default AddSubscription;
